import Image from 'next/image';

import { Box, Flex, Heading, Text } from '@chakra-ui/react';

import { ButtonLink } from '~/components/button-link';
import { trackEvent } from '~/features/analytics/track-event';
import { HeroLayout } from '~/features/experiments/ab_plp_redesign_2025/components/hero-layout';
import { CircleArrowRightIcon } from '~/features/experiments/ab_plp_redesign_2025/icons';
import { governmentHeroContent } from '~/features/government/configs/hero-content';

export function GovernmentHero() {
  const { title, description, cta, backgroundImages } = governmentHeroContent;

  return (
    <HeroLayout
      backgroundImageOverlayGradient={null}
      backgroundImageSlot={
        <>
          <Box display={{ base: 'block', md: 'none' }} inset={0} position='absolute'>
            <Image
              alt=''
              quality={100}
              sizes='100vw'
              src={backgroundImages.mobile}
              style={{
                objectFit: 'cover',
                objectPosition: 'top',
              }}
              fill
              priority
            />
          </Box>
          <Box bottom='-2px' display={{ base: 'none', md: 'block' }} left={0} position='absolute' right={0} top={0}>
            <Image
              alt=''
              quality={100}
              sizes='100vw'
              src={backgroundImages.desktop}
              style={{
                objectFit: 'cover',
                objectPosition: 'top',
              }}
              fill
              priority
            />
          </Box>
          <Box
            display={{ base: 'block', md: 'none' }}
            inset={0}
            pointerEvents='none'
            position='absolute'
            sx={{
              background: 'linear-gradient(to top, #000 0%, rgba(0, 0, 0, 0.78) 49%, rgba(0, 0, 0, 0) 72%)',
            }}
          />
          <Box
            display={{ base: 'none', md: 'block' }}
            inset={0}
            pointerEvents='none'
            position='absolute'
            sx={{
              background: 'linear-gradient(90deg, #000 0%, rgba(0, 0, 0, 0) 46%, rgba(0, 0, 0, 0) 76%, #000 100%)',
            }}
          />
        </>
      }
      contentContainerProps={{
        contentMaxWidth: 'content-max-width-2xl',
        paddingStart: {
          base: '16px',
          md: '24px',
        },
        paddingEnd: {
          base: '16px',
          md: '24px',
        },
      }}
      ctaSlot={
        <ButtonLink
          buttonProps={{
            colorScheme: 'blue',
            flex: {
              base: 1,
              md: 'unset',
            },
            leftIcon: <CircleArrowRightIcon height='18px' width='18px' />,
            size: 'icon-left',
            variant: 'solid',
            onClick: () => {
              trackEvent({
                type: 'click',
                name: 'Government CTA Clicked',
                label: 'learn_more_clicked',
                value: 'hero',
              });
            },
          }}
          linkProps={{
            href: cta.href,
          }}
        >
          {cta.label}
        </ButtonLink>
      }
      minHeight={{
        md: '640px',
      }}
      textAndCtaContainerProps={{
        gap: {
          base: 6,
          md: '40px',
        },
      }}
      textContentSlot={
        <Flex
          flexDirection='column'
          whiteSpace='pre-wrap'
          gap={{
            base: 4,
            md: 6,
          }}
          marginTop={{
            base: '192px',
            md: 'unset',
          }}
          maxWidth={{
            md: '630px',
          }}
        >
          <Heading
            as='h1'
            color='white'
            fontWeight='500'
            fontSize={{
              base: '2.375rem',
              md: '4.75rem',
            }}
            letterSpacing={{
              base: '-0.02em',
              md: '-0.02em',
            }}
            lineHeight={{
              base: '1.1',
              md: '1',
            }}
          >
            {title}
          </Heading>
          <Text
            color='grey.100'
            fontSize={{ base: 'md', md: 'lg' }}
            lineHeight='lg'
            maxWidth={{ base: '100%', md: '432px' }}
          >
            {description}
          </Text>
        </Flex>
      }
    />
  );
}
